const steps = [
  {
    n: "01",
    title: "Assess",
    body:
      "We identify what is exposed, misconfigured, over-permissioned, or vulnerable across AI systems, applications, agents, data flows, vendors, and workflows.",
    outcome:
      "Leadership knows what the AI touches, what it can affect, and where the highest-risk exposure lives.",
  },
  {
    n: "02",
    title: "Remediate",
    body:
      "We help close the highest-risk gaps through practical remediation, control design, secure workflow changes, and evidence-driven prioritization.",
    outcome:
      "The exposure is reduced. The controls exist. The fixes are scoped, owned, and shipped.",
  },
  {
    n: "03",
    title: "Validate",
    body:
      "We test the fixes, verify the controls, and produce evidence that supports customer, audit, insurance, regulatory, executive, and board-level review.",
    outcome:
      "You have proof, not assumptions. AI can operate, sell, audit, insure, and scale with confidence.",
  },
];

export default function ArqHowItWorks() {
  return (
    <section id="how-it-works" className="bg-arq-bg py-20 md:py-[120px] px-6">
      <div className="max-w-[1200px] mx-auto">
        <div className="text-center max-w-[820px] mx-auto mb-16">
          <div className="arq-label mb-6">The Methodology</div>
          <h2 className="font-display font-semibold text-arq-text mb-4" style={{ fontSize: "clamp(28px, 4vw, 40px)", lineHeight: 1.2 }}>
            Assess. Remediate. Validate.
          </h2>
          <p className="text-arq-muted text-[16.5px] leading-[1.7]">
            Find what is exposed. Fix what matters. Prove what is secure.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {steps.map((s) => (
            <div key={s.n} className="arq-card p-7 flex flex-col">
              <div className="font-mono-tech text-[12px] text-arq-blue mb-3 tracking-[0.08em]">{s.n}</div>
              <h3 className="font-display text-[22px] font-semibold text-arq-text mb-3">{s.title}</h3>
              <p className="text-arq-muted text-[14.5px] leading-[1.7] mb-5 flex-1">{s.body}</p>
              <div className="pt-4 border-t border-arq-border">
                <div className="font-mono-tech text-[10.5px] tracking-[0.1em] uppercase text-arq-teal mb-2">
                  Outcome
                </div>
                <p className="text-arq-text/90 text-[13.5px] leading-[1.6]">{s.outcome}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
